import {ChildEntity} from "typeorm";
import {Notification} from "@/modules/notifications/entity";
import CurrencyExchangeNotificationComponent
  from "@/modules/action-points/components/CurrencyExchangeNotification.vue";
import {Component} from "@vue/runtime-core";
import {ShallowRef} from "vue";
import {GateTypeEnum} from "@/modules/action-points/enums";

@ChildEntity()
export class CurrencyExchangeNotification extends Notification {
  setPayload(type: GateTypeEnum, coins: number, balanceGain: number) {
    this.payloadRaw = JSON.stringify({type, coins, balanceGain});

    return this;
  }

  get payload(): { type: GateTypeEnum, coins: number, balanceGain: number } {
    return JSON.parse(this.payloadRaw!);
  }

  get component(): ShallowRef<Component> {
    return shallowRef(CurrencyExchangeNotificationComponent);
  }
}